<template>
  <el-dialog
    v-model="dialogFormVisible"
    title="客户经理邀请码"
    width="500px"
    @close="close"
  >
    <el-form label-width="80px">
      <el-form-item label="姓名">
        {{ name }}
      </el-form-item>
      <el-form-item label="工号">
        {{ customId }}
      </el-form-item>
      <el-form-item label="邀请码">
        <img class="avatar" :src="qrcode" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">关 闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import storejs from 'store'
  import { getStaffShareCode } from '@/api/branch'

  export default {
    name: 'BranchRoleShareCode',
    data() {
      return {
        name: '',
        customId: '',
        peopleId: '',
        qrcode: '',
        dialogFormVisible: false,
      }
    },
    mounted() {
      const me = storejs.get('me')
      this.branchId = me.extra.branchId || ''
    },
    methods: {
      async getShareCode() {
        const ret = await getStaffShareCode({
          peopleId: this.peopleId,
        })
        this.qrcode = ret.url
      },
      showShareCode(row) {
        this.name = row.basic.name
        this.customId = row.basic.customId
        this.peopleId = row.peopleId
        this.dialogFormVisible = true
        this.getShareCode()
      },
      close() {
        this.dialogFormVisible = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .avatar {
    width: 120px;
    height: 120px;
  }
</style>
